module.exports = __webpack_public_path__ + "static/img/14010102.273a6f79.png";